// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-72EA2AD5-9027-456E-BDA1-B305CFFE23B8.v-72ea2ad5-9027-456e-bda1-b305cffe23b8-ltr {\n  direction: ltr;\n}\n", "",{"version":3,"sources":["webpack://src/common/userMainWindow/messageBox/messageBox.less"],"names":[],"mappings":"AACI;EACI,cAAA;AAAR","sourcesContent":["#V-72EA2AD5-9027-456E-BDA1-B305CFFE23B8{\n    &.v-72ea2ad5-9027-456e-bda1-b305cffe23b8-ltr{\n        direction: ltr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
